import React from 'react';
import { Error500 } from './ProductionErrorPages';

type Props = { children: React.ReactNode };

type State = { hasError: boolean };

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: any) {
    // Log to console for developer debugging
    // In production you might send this to an error tracking service
    console.error('ErrorBoundary caught an error', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <Error500 onRetry={() => window.location.reload()} onDashboard={() => { window.location.href = '/dashboard'; }} />;
    }
    return this.props.children as React.ReactElement;
  }
}
